import { createSlice } from "@reduxjs/toolkit";

export const clientDetailsSlice = createSlice({
  name: "clientDetails",
  initialState: {
    clientDetails: null,
  },
  reducers: {
    clientDetailsUpdate: (state, action) => {
      state.clientDetails = action.payload;
    },
    clientDetailsReset: (state) => {
      state.clientDetails = null;
    },
  },
});

export const { clientDetailsUpdate, clientDetailsReset } =
  clientDetailsSlice.actions;

export const getClientDetails = (state: any) =>
  state.clientDetails.clientDetails;

export default clientDetailsSlice.reducer;
